module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("举报管理")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    staticClass: "search-row",
    attrs: {
      "inline": true,
      "model": _vm.queryParam,
      "label-width": "82px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "动态ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "精确搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.dynamicId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "dynamicId", $$v)
      },
      expression: "queryParam.dynamicId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "精确搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.userId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userId", $$v)
      },
      expression: "queryParam.userId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.nickName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickName", $$v)
      },
      expression: "queryParam.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "380px"
    },
    attrs: {
      "clearable": "",
      "type": "datetimerange",
      "range-separator": "至",
      "placeholder": "请选择开始时间至结束时间",
      "format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.queryParam.publishTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "publishTime", $$v)
      },
      expression: "queryParam.publishTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "search-action-item"
  }, [_c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSearch
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-button-group', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, _vm._l((_vm.statusTabs), function(tab) {
    return _c('el-button', {
      key: tab.value,
      class: [
        'status-tab-btn',
        {
          'is-active': _vm.queryParam.reportTab === tab.value
        } ],
      on: {
        "click": function($event) {
          return _vm.setTab(tab.value)
        }
      }
    }, [_vm._v(_vm._s(tab.label))])
  }), 1), _vm._v(" "), _c('el-table', {
    ref: "reportTable",
    attrs: {
      "data": _vm.listData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "动态ID",
      "min-width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userId",
      "label": "用户ID",
      "min-width": "110",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.routeDynamicDetail(row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(row.userId) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickname",
      "label": "昵称",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorTypeText",
      "label": "类型",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "内容",
      "min-width": "200",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.content) ? _c('span', [_vm._v(_vm._s(row.content))]) : _c('span', [_vm._v("无")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片数量/视频时长",
      "min-width": "170",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.images && row.images.length) ? _c('div', {
          staticClass: "media-cell"
        }, [_c('div', {
          staticClass: "media-grid"
        }, [_c('span', {
          staticClass: "media-item",
          on: {
            "click": function($event) {
              _vm.openMedia(_vm.mediaList(row), 0)
            }
          }
        }, [(_vm.mediaList(row)[0].type === 'image') ? _c('img', {
          staticClass: "media-thumb",
          attrs: {
            "src": _vm.mediaList(row)[0].url,
            "alt": "图片"
          }
        }) : _c('span', {
          staticClass: "media-video"
        }, [_c('i', {
          staticClass: "media-play"
        }, [_vm._v("▶")])]), _vm._v(" "), _c('div', {
          staticClass: "under-dot"
        }, [_vm._v("\n                  " + _vm._s((row && row.images && row.images.length) || "") + "\n                ")])])])]) : _c('span', [_vm._v("无")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联话题",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.topics && row.topics.length) ? _vm._l((row.topics), function(t, i) {
          return _c('el-tag', {
            key: i,
            staticClass: "topic-tag",
            attrs: {
              "type": "info",
              "size": "small"
            }
          }, [_vm._v(_vm._s(t.name || t.topicName))])
        }) : _c('span', [_vm._v("无")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sportsRecordText",
      "label": "跑步记录",
      "min-width": "330",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishedAt",
      "label": "发布时间",
      "min-width": "170",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), (_vm.queryParam.reportTab === 3) ? _c('el-table-column', {
    attrs: {
      "prop": "auditMsg",
      "label": "驳回原因",
      "width": "160"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportReason",
      "label": "举报原因",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportTimeText",
      "label": "举报时间",
      "min-width": "170",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) { return (a.reportTime || 0) - (b.reportTime || 0); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "举报人",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.reportNickName || "无") + _vm._s(row.reportUid ? "（" + row.reportUid + "）" : ""))]
      }
    }])
  }), _vm._v(" "), (_vm.queryParam.reportTab === 1) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openAudit(row)
            }
          }
        }, [_vm._v("审核")])]
      }
    }], null, false, 1659501011)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    staticClass: "pagination-seq"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "current-page": _vm.queryParam.pageNum,
      "page-size": _vm.queryParam.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "动态审核",
      "size": "small",
      "visible": _vm.auditDialog.visible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.auditDialog, "visible", $event)
      },
      "close": _vm.resetAuditForm
    }
  }, [(_vm.auditDialog.row) ? _c('el-form', {
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "动态ID"
    }
  }, [_vm._v(_vm._s(_vm.auditDialog.row.id))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "举报原因"
    }
  }, [_vm._v(_vm._s(_vm.auditDialog.row.reportReason || "无"))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核状态",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.auditDialog.form.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog.form, "auditStatus", $$v)
      },
      expression: "auditDialog.form.auditStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("不通过")])], 1), _vm._v(" "), (_vm.auditDialog.form.auditStatus === 1) ? _c('div', [_vm._v("\n          通过后，帖子依然正常显示\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.auditDialog.form.auditStatus === 2) ? [_c('el-form-item', {
    attrs: {
      "label": "驳回原因",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "placeholder": "请选择驳回原因"
    },
    model: {
      value: (_vm.auditDialog.form.rejectReason),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog.form, "rejectReason", $$v)
      },
      expression: "auditDialog.form.rejectReason"
    }
  }, _vm._l((_vm.rejectReasons), function(r, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "label": r.label,
        "value": i + 1
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.auditDialog.form.rejectReason === 7) ? _c('el-form-item', {
    attrs: {
      "label": "其他原因"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请输入驳回原因"
    },
    model: {
      value: (_vm.auditDialog.form.customReason),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog.form, "customReason", $$v)
      },
      expression: "auditDialog.form.customReason"
    }
  })], 1) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.auditDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmAudit
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "预览",
      "visible": _vm.mediaPreview.visible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.mediaPreview, "visible", $event)
      },
      "close": _vm.closeMedia
    }
  }, [_c('div', {
    staticClass: "media-preview-body"
  }, [(_vm.currentMedia && _vm.currentMedia.type === 'image') ? _c('img', {
    staticClass: "media-preview",
    attrs: {
      "src": _vm.currentMedia.url,
      "alt": "预览"
    }
  }) : (_vm.currentMedia) ? _c('video', {
    staticClass: "media-preview",
    attrs: {
      "src": _vm.currentMedia.url,
      "controls": "",
      "autoplay": ""
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.mediaPreview.list.length > 1) ? _c('div', {
    staticClass: "media-preview-nav"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.mediaPreview.index === 0
    },
    on: {
      "click": _vm.prevMedia
    }
  }, [_vm._v("上一个")]), _vm._v(" "), _c('span', {
    staticClass: "media-preview-count"
  }, [_vm._v(_vm._s(_vm.mediaPreviewText))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.mediaPreview.index === _vm.mediaPreview.list.length - 1
    },
    on: {
      "click": _vm.nextMedia
    }
  }, [_vm._v("下一个")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6265995e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/Dynamics/ReportManage/ReportManage.vue
// module id = 1047
// module chunks = 0